import type { BrowserOptions } from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { registerGlobalEventScrubbing, scrubSentryEvent } from './piiSanitizer';

const tracesSampleRate = process.env.RAILS_ENV === 'production' ? 0.01 : 0;

// beforeSend はエラーイベントのみに適用され、トランザクションイベント
// （BrowserTracing の pageload/navigation）には適用されない。トランザクション
// にも同じスクラブを適用するため、グローバルイベントプロセッサとして併用登録する。
registerGlobalEventScrubbing();

const sentryInitOption: BrowserOptions = {
  dsn: process.env.SENTRY_CLIENT_DSN,
  integrations: [new BrowserTracing()],
  ignoreErrors: ['FirebaseError'],
  beforeSend: scrubSentryEvent,

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: tracesSampleRate,
};

export default sentryInitOption;
